import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Pagination, Search } from "../../../Table";
import Loader from "../../../Include/Loader";
import moment from "moment";
import toast from "react-hot-toast";
import { V_URL } from "../../../../../BaseUrl";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Swal from "sweetalert2";
import axios from "axios";
import { getPurRequest } from "../../../../../Store/prosafe/proTransaction/PurRequest/getPurRequest";
import { getStatusLabel } from "../../components/ProStatus/StatusFile";
import Footer from "../../../Include/Footer";
import { verifyPr } from "../../../../../Store/Admin/believe/PurchaseRequest/verifyPr";
import { approveStorePr } from "../../../../../Store/prosafe/proTransaction/PurRequest/approveStorePr";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import { getAdminItem } from "../../../../../Store/Store/Item/AdminItem";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getCategory } from "../../../../../Store/Store/StoreMaster/Category/Category";
import useDebounce from "../../../../../hooks/useDebounce";

const PurRequestList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
    item: null,
    category: null,
    project: null,
  });

  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    fetchData();
  }, [debouncedSearch, filter, currentPage, limit]);

  useEffect(() => {
    dispatch(getAdminItem({ is_main: true }));
    dispatch(getProject());
    dispatch(getCategory());
  }, [dispatch]);

  const fetchData = () => {
    const payload = {
      tag_number: 9,
      search: debouncedSearch,
      start_date: filter.startDate,
      end_date: filter.endDate,
      item_id: filter.item,
      item_category_id: filter.category,
      project_id: filter.project,
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
    };
    dispatch(getPurRequest({ formData: payload }));
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(1);
  };

  const entity = useSelector((state) => state?.getPurRequest?.user?.data) || [];
  const isLoading = useSelector((state) => state?.getPurRequest?.loading);
  const itemData = useSelector((state) => state?.getAdminItem?.user?.data);
  const projectData = useSelector((state) => state?.getProject?.user?.data);
  const categoryData = useSelector((state) => state?.getCategory?.user?.data);

  const commentsData = useMemo(() => {
    let data = [...entity];
    setTimeout(() => setTotalItems(data.length), 0);
    return data.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit,
    );
  }, [entity, currentPage, limit]);

  const handleRefresh = () => {
    // fetchData();
    setFilter({
      startDate: null,
      endDate: null,
      item: null,
      category: null,
      project: null,
    });
  };

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const myurl = `${V_URL}/prosafe/pro-delete-pr`;
        var bodyFormData = new URLSearchParams();
        bodyFormData.append("id", id);
        axios({
          method: "put",
          url: myurl,
          data: bodyFormData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        })
          .then((response) => {
            if (response.data.success === true) {
              toast.success(response?.data?.message);
              fetchData();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((error) => {
            toast.error(
              error?.response?.data?.message || "Something went wrong",
            );
          });
      }
    });
  };

  const handlePrDownload = async (id) => {
    try {
      const res = await axios.post(
        `${V_URL}/prosafe/download-pr-pdf/${id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        },
      );
      if (res?.data?.success === true) {
        window.open(res?.data?.data?.url);
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadExcel = async () => {
    try {
      const payload = {
        tag_number: 9,
        search,
        start_date: filter.startDate,
        end_date: filter.endDate,
        item_id: filter.item,
        item_category_id: filter.category,
        project_id: filter.project,
        firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
        year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      };

      const res = await axios.post(
        `${V_URL}/prosafe/pro-pr-xlsx-download`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        }
      );

      if (res?.data) {
        window.open(res?.data?.data?.url);
        toast.success(res?.data?.message || "Excel downloaded successfully");
      } else {
        toast.error("Failed to download");
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || "Download failed");
    }
  };

  const handleVerify = async (id, voucher_no) => {
    try {
      const result = await Swal.fire({
        title: `PR Verification for ${voucher_no}`,
        text: "Do you want to verify or reject this PR?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Verify",
        denyButtonText: "Reject",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#28a745",
        denyButtonColor: "#d33",
      });

      // User selected VERIFY
      if (result.isConfirmed) {
        const res = await dispatch(verifyPr({ id }));

        Swal.fire({
          icon: res?.payload?.success ? "success" : "error",
          title: res?.payload?.success ? "Verified!" : "Error",
          text: res?.payload?.message || "",
        });

        fetchData();
        return;
      }

      // User selected REJECT
      if (result.isDenied) {
        const { value: reject_reason } = await Swal.fire({
          title: `Reject PR ${voucher_no}`,
          input: "textarea",
          inputLabel: "Reason for rejection",
          inputPlaceholder: "Enter reason...",
          inputAttributes: { "aria-label": "Enter reason" },
          showCancelButton: true,
          confirmButtonText: "Submit",
          confirmButtonColor: "#d33",
        });

        // If no reason → cancel
        if (!reject_reason) {
          Swal.fire(
            "Cancelled",
            "Rejection cancelled or no reason added.",
            "info",
          );
          return;
        }

        // API call with id + reject_reason
        const res = await dispatch(verifyPr({ id, reject_reason }));

        Swal.fire({
          icon: res?.payload?.success ? "success" : "error",
          title: res?.payload?.success ? "Rejected!" : "Error",
          text: res?.payload?.message || "",
        });

        fetchData();
      }
    } catch (err) {
      console.log(err);
      Swal.fire("Error!", "Something went wrong!", "error");
    }
  };

  const handleFinalApprove = async (id, voucher_no, isApproval = true) => {
    try {
      if (isApproval) {
        const result = await Swal.fire({
          title: `Final Approve PR - ${voucher_no}`,
          text: "Are you sure you want to perform Final Approval for this Purchase Request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, Approve",
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
        });

        if (!result.isConfirmed) return;

        const payload = {
          id,
          status: 3,
          accrej_time: moment().format("HH:mm"),
        };

        const res = await dispatch(approveStorePr(payload));

        Swal.fire({
          icon: res?.payload?.success ? "success" : "error",
          title: res?.payload?.success ? "Approved!" : "Error",
          text: res?.payload?.message || "",
        });

        fetchData();
      } else {
        const { value: rej_reason } = await Swal.fire({
          title: `Reject PR - ${voucher_no}`,
          input: "textarea",
          inputLabel: "Reason for rejection",
          inputPlaceholder: "Enter rejection reason...",
          inputAttributes: { "aria-label": "Enter reason" },
          showCancelButton: true,
          confirmButtonText: "Submit Rejection",
          confirmButtonColor: "#d33",
        });

        if (!rej_reason) {
          Swal.fire(
            "Cancelled",
            "Rejection cancelled or no reason provided.",
            "info"
          );
          return;
        }

        const payload = {
          id,
          status: 4,
          accrej_time: moment().format("HH:mm"),
          rej_reason,
        };

        const res = await dispatch(approveStorePr(payload));

        Swal.fire({
          icon: res?.payload?.success ? "success" : "error",
          title: res?.payload?.success ? "Rejected!" : "Error",
          text: res?.payload?.message || "",
        });

        fetchData();
      }
    } catch (err) {
      console.log(err);
      Swal.fire("Error!", "Something went wrong during approval", "error");
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const breadCrumbs = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Purchase Request" },
  ];

  const filterConfig = [
    {
      key: "item",
      label: "Item",
      type: "dropdown",
      value: filter.item,
      placeholder: "Select Item",
      searchable: true,
      options:
        itemData?.map((item) => ({ label: item.name, value: item._id })) || [],
    },
    {
      key: "category",
      label: "Item Category",
      type: "dropdown",
      value: filter.category,
      placeholder: "Select Item Category",
      searchable: true,
      options:
        categoryData?.map((category) => ({
          label: category.name,
          value: category._id,
        })) || [],
    },
    {
      key: "project",
      label: "Project",
      type: "dropdown",
      value: filter.project,
      placeholder: "Select Project",
      searchable: true,
      options:
        projectData?.map((project) => ({
          label: `${project.name} (${project.project_no})`,
          value: project._id,
        })) || [],
    },
    {
      key: "startDate",
      label: "Start Date",
      type: "date",
      value: filter.startDate,
      placeholder: "Select Start Date",
    },
    {
      key: "endDate",
      label: "End Date",
      type: "date",
      value: filter.endDate,
      placeholder: "Select End Date",
    },
  ];

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">

                  <PageHeader
                    title="Purchase Request"
                    breadcrumbs={breadCrumbs}
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                    addButtonLink="/main-store/user/manage-purchase-request"
                    onRefresh={handleRefresh}
                    filter={filter}
                    onFilterChange={handleFilterChange}
                    limit={limit}
                    onLimitChange={(val) => setlimit(val)}
                    filterConfig={filterConfig}
                    onDownload={handleDownloadExcel}
                  />

                  {isLoading ? (
                    <Loader />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>PR Date</th>
                            <th>PR No.</th>
                            {/* <th>Project No</th> */}
                            {/* <th>Item Count</th> */}
                            <th>Total Qty</th>
                            <th>Total Amount (₹)</th>
                            <th>Department</th>
                            <th>Project</th>
                            <th>Prepared By</th>
                            <th>Approved By</th>
                            <th>Status</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.map((elem, i) => (
                            <tr key={elem?._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>
                                {moment(elem.trans_date).format("YYYY-MM-DD")}
                              </td>
                              <td>{elem.voucher_no}</td>

                              {/* <td>{elem?.manual_pro_no || "-"}</td> */}
                              {/* <td>{elem.item_count || 0}</td> */}
                              <td>{elem.total_qty || 0}</td>
                              <td>{elem.total_amount?.toFixed(2) || 0}</td>
                              <td>{elem.department_name || "-"}</td>
                              <td>
                                {`${elem.project_details?.name} ${elem.project_details?.project_no
                                  ? `(${elem.project_details?.project_no})`
                                  : ""
                                  }` || "-"}
                              </td>
                              <td>{elem?.prepare_by?.name || "-"}</td>
                              <td>
                                {elem?.approve_by?.name ? (
                                  <span>
                                    {elem?.approve_by?.name}
                                    {elem?.approve_by?.approved_type === "STORE_USER" && (
                                      <small className="d-block text-success fw-bold">(Main Store)</small>
                                    )}
                                    {elem?.approve_by?.approved_type === "ADMIN" && (
                                      <small className="d-block text-primary fw-bold">(Admin)</small>
                                    )}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>{getStatusLabel(elem.status)}</td>
                              <td className="text-end">
                                <div className="dropdown dropdown-action">
                                  <a
                                    href="#"
                                    className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="fa fa-ellipsis-v"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/main-store/user/view-purchase-request`,
                                          { state: elem },
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-eye m-r-5"></i>{" "}
                                      View
                                    </button>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/main-store/user/manage-purchase-request`,
                                          { state: elem },
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                      Edit
                                    </button>
                                    {(elem.status === 1 || elem.status === 2) && (
                                      <>
                                        {elem.status === 1 && (
                                          <button
                                            type="button"
                                            className="dropdown-item text-primary"
                                            onClick={() =>
                                              handleVerify(
                                                elem?._id,
                                                elem.voucher_no,
                                              )
                                            }
                                          >
                                            <i className="fa-solid fa-circle-check m-r-5"></i>
                                            Verify PR
                                          </button>
                                        )}
                                        <button
                                          type="button"
                                          className="dropdown-item text-success"
                                          onClick={() =>
                                            handleFinalApprove(
                                              elem?._id,
                                              elem.voucher_no,
                                              true,
                                            )
                                          }
                                        >
                                          <i className="fa-solid fa-check-double m-r-5"></i>
                                          Approve PR (Final)
                                        </button>
                                        <button
                                          type="button"
                                          className="dropdown-item text-danger"
                                          onClick={() =>
                                            handleFinalApprove(
                                              elem?._id,
                                              elem.voucher_no,
                                              false,
                                            )
                                          }
                                        >
                                          <i className="fa-solid fa-ban m-r-5"></i>
                                          Reject PR
                                        </button>
                                        {elem.status === 1 && (
                                          <button
                                            type="button"
                                            className="dropdown-item text-danger"
                                            onClick={() =>
                                              handleDelete(
                                                elem?._id,
                                                elem.voucher_no,
                                              )
                                            }
                                          >
                                            <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                            Delete
                                          </button>
                                        )}
                                      </>
                                    )}
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        handlePrDownload(elem?._id)
                                      }
                                    >
                                      <i className="fa-solid fa-download m-r-5"></i>{" "}
                                      Download PR
                                    </button>
                                  </div>
                                </div>
                              </td>

                            </tr>
                          ))}
                          {commentsData?.length === 0 ? (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                        data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PurRequestList;
